import { render } from "./AboutRootsDesktop.vue?vue&type=template&id=8713b5d2&scoped=true"
import script from "./AboutRootsDesktop.vue?vue&type=script&lang=js"
export * from "./AboutRootsDesktop.vue?vue&type=script&lang=js"

import "./AboutRootsDesktop.vue?vue&type=style&index=0&id=8713b5d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8713b5d2"]])

export default __exports__